module.exports = __webpack_public_path__ + "img/MTCIIIGB.aca32c49.png";